import React, { useEffect, useState } from "react";
import styles from "./BottomNavigationBar.module.css";
import { Link, useLocation } from "react-router-dom";
import Axios from "@/Axios";
import { useConfirm } from "@components";
import { ReactComponent as AIIcon } from "../assets/images/ai-bottomnavi.svg";

const BottomNavigationBar = React.memo(function ({ className }) {
  const confirm = useConfirm();
  const location = useLocation();
  const defaultState = {
    isReels: false,
    isProducts: false,
    isDetail: false,
    homeNm: "",
    reelsNm: "",
    productsNm: "",
    detailNm: "",
    isViewFlags: {
      home: false,
      reels: false,
      products: false,
      detail: false,
    },
  };
  const [state, setState] = useState(defaultState);
  const onStyles = {
    reelsIcon: {
      backgroundImage: `url(/images/reels-on.png)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    productsIcon: {
      backgroundImage: `url(/images/products-on.png)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    detailIcon: {
      backgroundImage: `url(/images/detail-on.png)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    text: { color: "#171712" },
  };

  const resetState = () => {
    setState(defaultState);
  };
  const scrollTop = () => {
    window.scrollTo(0, 0);
  };
  const switchState = () => {
    const path = location.pathname;
    switch (true) {
      case path.startsWith("/reels-category"):
      case path.startsWith("/reels-list"):
      case path.startsWith("/reels-content"):
        setState((s) => ({ ...s, isReels: true }));
        break;
      case path.startsWith("/product-list"):
        setState((s) => ({ ...s, isProducts: true }));
        break;
      case path.startsWith("/detail-category"):
      case path.startsWith("/detail-list"):
      case path.startsWith("/detail-contents"):
        setState((s) => ({ ...s, isDetail: true }));
        break;
      default:
        alert("bottom navigation is not allowed.");
        break;
    }
  };

  const findAll = () => {
    Axios.get("/api/home/list", { params: {} }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      const homes = res?.data?.homes;
      const data = homes ? homes[0] : {};
      setState((s) => ({
        ...s,
        homeNm: data.homeMenuNm,
        reelsNm: data.reelsMenuNm,
        productsNm: data.productsMenuNm,
        detailNm: data.detailMenuNm,
        isViewFlags: data.isViewFlags,
      }));
    });
  };

  useEffect(() => {
    findAll();
    switchState();
    return resetState;
  }, []);

  return (
    <div
      className={
        className
          ? `${styles.footerNavigation} ${className}`
          : styles.footerNavigation
      }
    >
      <div className={styles.topLine} />
      <div className={styles.containerC}>
        {state.isViewFlags.home && (
          <Link to="/" className={styles.homeArea}>
            <div className={styles.homeIcon} />
            <div className={styles.homeTextArea}>
              <span className={styles.home}>{state.homeNm}</span>
            </div>
          </Link>
        )}
        <Link to="/ai" className={styles.productIntroductionArea}>
          <AIIcon
            width={26}
            height={26}
            fill={"#898460"}
            style={{ color: "#898460" }}
          />
          <div className={styles.productIntroductionTextArea}>
            <span className={styles.productIntroduction}>AI</span>
          </div>
        </Link>
        {state.isViewFlags.reels && (
          <Link to="/reels-category" className={styles.releaseArea}>
            <div
              className={styles.releaseIcon}
              style={state.isReels ? onStyles.reelsIcon : null}
            />
            <div className={styles.releaseTextArea}>
              <span
                className={styles.releaseCollection}
                style={state.isReels ? onStyles.text : null}
              >
                {state.reelsNm}
              </span>
            </div>
          </Link>
        )}
        {state.isViewFlags.products && (
          <Link to="/product-list" className={styles.productIntroductionArea}>
            <div
              className={styles.productIntroductionIcon}
              style={state.isProducts ? onStyles.productsIcon : null}
            />
            <div className={styles.productIntroductionTextArea}>
              <span
                className={styles.productIntroduction}
                style={state.isProducts ? onStyles.text : null}
              >
                {state.productsNm}
              </span>
            </div>
          </Link>
        )}
        {/* 심화정보 오픈 메뉴에서 제외. 추후 다시 오픈 예정 */}
        {/* {state.isViewFlags.detail && (
          <Link
            to="/detail-category"
            className={styles.advancedInformationArea}
          >
            <div
              className={styles.advancedInformationIcon}
              style={state.isDetail ? onStyles.detailIcon : null}
            />
            <div className={styles.advancedInformationTextArea}>
              <span
                className={styles.advancedInformation}
                style={state.isDetail ? onStyles.text : null}
              >
                {state.detailNm}
              </span>
            </div>
          </Link>
        )} */}
        <div className={styles.footerIconArea}>
          <div className={styles.footerIcon} onClick={scrollTop} />
        </div>
      </div>
    </div>
  );
});

export default BottomNavigationBar;
